import { render, staticRenderFns } from "./SearchAmendment.vue?vue&type=template&id=5f52360e&scoped=true&"
import script from "./SearchAmendment.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./SearchAmendment.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./SearchAmendment.vue?vue&type=style&index=0&id=5f52360e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f52360e",
  null
  
)

export default component.exports